import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localeDate',
    standalone: true,
    pure: false
})
export class LocaleDatePipe implements PipeTransform {
    constructor(
        private datePipe: DatePipe,
        private translateService: TranslateService
    ) {}

    transform(value: any, format: string = 'longDate'): string {
        if (!value) return '';

        return this.datePipe.transform(value, format, undefined, this.translateService.currentLang) || '';
    }
}
